module.exports = __webpack_public_path__ + "static/media/1021399.348e8461.jpg";